import { render, staticRenderFns } from "./LglAutorizeDetail.vue?vue&type=template&id=66452085&"
import script from "./LglAutorizeDetail.vue?vue&type=script&lang=js&"
export * from "./LglAutorizeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports